import type { App } from 'antd';

type AntdAppApis = ReturnType<typeof App.useApp>;

let currentApis: AntdAppApis | null = null;

export const setAntdAppApis = (apis: AntdAppApis) => {
  currentApis = apis;
};

export const getAntdAppApis = () => currentApis;
